import { transferStatusConfig } from '@/constants/transfer'
import { useUI } from '@/hooks/useUI'

const fallbackConfig = { color: 'text-muted-foreground', bgColor: 'bg-secondary' }

export function TransferStatusBadge({ status }: { status: string }) {
  const { transferStatuses, getEnumLabel } = useUI()
  const config = transferStatusConfig[status] ?? fallbackConfig

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-medium ${config.bgColor} ${config.color}`}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {getEnumLabel(transferStatuses, status)}
    </span>
  )
}
